import { useAppSelector } from '@verantos-dev/app-state-base';
import {
  selectCohortDefinitionIsVersionLoading,
  selectCohortProfileIsLoading,
  selectIsEditable,
  useCohortDefinitionStore,
} from '@verantos-dev/app-state-cohort-definition';

/**
 * Returns owner/editor permission for the current cohort plus loading flags.
 *
 * `isEditable` is sourced from the Zustand `useCohortDefinitionStore` — kept
 * in sync with the server by `useCohortProfileData` (called inside
 * `useCohortDefinitionLifecycle`). Loading flags remain on the legacy Redux
 * slice; they'll move with the broader slice retirement in a follow-up PR.
 */
export const useCohortEditable = () => {
  const isEditable = useCohortDefinitionStore(selectIsEditable);
  const isCohortProfileLoading = useAppSelector(selectCohortProfileIsLoading);
  const isCohortVersionLoading = useAppSelector(selectCohortDefinitionIsVersionLoading);
  return {
    isEditable,
    isCohortProfileLoading,
    isCohortVersionLoading,
  };
};
